import {isMobile, partnerData} from './commonMethods';
import {globalImport} from '../common/globalImports';
import {Color} from '../assets';
import {
  account_profile,
  account_raiseTicket,
  account_refer,
  account_support,
  account_telegram,
  accountTab,
  accountTab_selected,
  back_arrow,
  cancel_black,
  close,
  coin,
  cross_new,
  down_arrow,
  event_about,
  fantasyTab,
  fantasyTab_selected,
  gift,
  home_sort,
  ic_minus,
  ic_plus,
  info,
  learnTab,
  left_arrow_black,
  liveTab,
  liveTab_selected,
  logoName,
  markets_empty,
  marketTab,
  marketTab_selected,
  nothing_card_closed,
  nothing_card_live,
  portfolio_empty,
  portfolioTab,
  portfolioTab_selected,
  right_arrow,
  right_arrow_black,
  tick_new,
  tip_image,
  transactions_add,
  transactions_invest,
  transactions_withdraw,
  up_arrow,
  walletTab,
  walletTab_selected,
  warning,
  WhatsApp,
  activityTab,
  activityTab_selected,
  more,
  more_selected,
  tradex_markets,
  share_button,
} from './images';
import Colors from '../assets/Color/Colors';
import {
  bottomIcon,
  bottomIconTheme1,
  BottomTabTheme1,
  globalConfigurableDataTheme1,
  GlobalScreensTheme1,
} from './globalConstantTheme1';
import {
  bottomIconThemeKostar,
  BottomTabThemeKostar,
  globalConfigurableDataThemeKostar,
  GlobalScreensThemeKostar,
} from './globalConstantKostart';
import {
  bottomIconThemeMyMaster,
  BottomTabThemeMyMaster,
  globalConfigurableDataMyMaster,
  GlobalScreensThemeMyMaster,
} from './globalConstantMyMaster';

export const partnerMap = {
  isKostar:
    (process.env.REACT_APP_ENV === 'prod' && +globalImport?.PARTNER_ID === 4) ||
    (process.env.REACT_APP_ENV !== 'prod' && +globalImport?.PARTNER_ID === 9),
  isMyMaster:
    (process.env.REACT_APP_ENV === 'prod' && +globalImport?.PARTNER_ID === 6) ||
    (process.env.REACT_APP_ENV !== 'prod' && +globalImport?.PARTNER_ID === 10),
  isTmr:
    (process.env.REACT_APP_ENV === 'prod' && +globalImport?.PARTNER_ID === 3) ||
    (process.env.REACT_APP_ENV !== 'prod' && +globalImport?.PARTNER_ID === 6),
};

export const globalConst = {
  appVersion: 2001,
  tradingFeeProbeLimit: process.env.REACT_APP_ENV === 'prod' ? 13101 : 14960,
  googleClientId: partnerMap?.isKostar
    ? '1027016681049-nqu1c8ivnqdbqiq5qmuj2fnb28mlsp6j.apps.googleusercontent.com'
    : '617121759028-pdstsn95v4i0n1c1hukm5g0f8i2sn4b3.apps.googleusercontent.com',
  MMNumbers: [
    '0931196164',
    '0981865825',
    '0987654321',
    '0548784634',
    '9311961064',
    '9962260591',
    '9717572288',
  ],
  recapatchaKey:
    process.env.REACT_APP_ENV === 'prod'
      ? '6LcaGsohAAAAAKuYYByy3sqNPKiH5gujvNmJedWr'
      : '6LfnNLchAAAAABXXbkGEINc89kVt-dZ1A3AfDZRL',
  appsflyerDevKey: 'txThR5Eba3PEQGZRhzPraF',
  partnerId: globalImport?.PARTNER_ID ? +globalImport?.PARTNER_ID : 1,

  isWeb: !isMobile(),
  appName: 'TradeX',
  buttonTimer: globalImport.isWeb ? 200 : 0,
};

export const BottomTab = {
  tabSelectedColor: Color.tradexBlue,
  tabUnselectedColor: Color.grey2,
  tabBottomBarColor: Color.bgWhite,
  tabTextData: [
    {
      icon: '',
      tabLabel: 'Markets',
      isVisible: '',
    },
    {
      icon: '',
      tabLabel: 'Portfolio',
      isVisible: '',
    },
    {
      icon: '',
      tabLabel: 'Rewards',
      isVisible: true,
    },
    {
      icon: '',
      tabLabel: 'Activity',
      isVisible: true,
    },
    {
      icon: '',
      tabLabel: 'Wallet',
      isVisible: true,
    },
  ],
  iconConfig: {
    market: 'tabler:smart-home',
    portfolio: 'tabler:briefcase',
    activity: 'tabler:activity-heartbeat',
    wallet: 'tabler:wallet',
    more: 'tabler:dots',
  },
};

export const globalConfigurableData = {
  appName: 'TradeX Markets',
  isMobileViewInDesktop: false,
  authButtonText: 'Register',
  switchTabSelectedColor: Colors.black,
  switchTabUnselectedColor: Colors.lightgrey,
  switchTabUnselectedBorderColor: Colors.borderColor,
  newSwitchTabBgColor: 'rgba(244, 244, 244, 1)',
  newSwitchTabSelectedBgColor: Colors.bgWhite,
  cardBgColor: Colors.bgWhite,
  logoUrl: tradex_markets,
  globalThemeColor: Color.bgWhite,
  fontColor: '',
  primaryTextColor: Color.black,
  secondaryTextColor: Color.bgWhite,
  tertiaryTextColor: '',
  headerColor: Color.bgWhite,
  primaryTextColor1: Color.black,
  secondaryTextColor1: Color.lightgrey,
  tertiaryTextColor1: Color.grey,
  quaternaryTextColor1: Color.grey1,
  contrastTextColor1: Color.bgWhite,
  alternateTextColor: Colors.bgWhite,
  errorTextColor1: Color.red,
  profitColor: Colors.green,
  lossColor: Colors.red,
  borderColor: Colors.borderColor,
  yesBtnBlock: Colors.yesColor,
  noBtnBlock: Colors.noColor,
  noBtnTxt: Colors.bgWhite,
  yesBtnTxt: Colors.bgWhite,
  loaderColor: Colors.black,
  disableBtnColor: Colors.bgWhite,
  disableBtnTextColor: Colors.black,
  yesBtnBlockInactive: Colors.yesColorInactive,
  noBtnBlockInactive: Colors.noColorInactive,
  yesBtnBlockInactiveTxt: Colors.yesColor,
  noBtnBlockInactiveTxt: Colors.noColor,
  primaryBtnColor: Color.tradexBlue,
  secondaryBtnColor: Color.black,
  primaryBtnTxt: Colors.bgWhite,
  greyBtnColor: Color.grey4,
  greyBtnTxt: Colors.black,
  btnBorderRadius: 8,
  imageBgColor: Color.lightgrey1,
  sortIcon: home_sort,
  back_arrow: back_arrow,
  cancel_black: cancel_black,
  close: close,
  cross_new: cross_new,
  down_arrow: down_arrow,
  event_about: event_about,
  gift: gift,
  info: info,
  right_arrow: right_arrow,
  tick_new: tick_new,
  transactions_add: transactions_add,
  transactions_invest: transactions_invest,
  transactions_withdraw: transactions_withdraw,
  up_arrow: up_arrow,
  warning: warning,
  WhatsApp: WhatsApp,
  tooltip: tip_image,
  right_arrow_black: right_arrow_black,
  left_arrow_black: left_arrow_black,
  ic_plus: ic_plus,
  ic_minus: ic_minus,
  nothing_card_live: nothing_card_live,
  nothing_card_closed: nothing_card_closed,
  coin: coin,
  markets_empty: markets_empty,
  portfolio_empty: portfolio_empty,
  initFunction: () => {},
  ...(partnerMap?.isTmr
    ? globalConfigurableDataTheme1
    : partnerMap?.isKostar
    ? globalConfigurableDataThemeKostar
    : partnerMap?.isMyMaster
    ? globalConfigurableDataMyMaster
    : {}),
};

export const GlobalScreens = {
  Home: {
    isShowBanner: true,
    howToTrade: true,
    isShowDefaultBanner: true,
    categorySelectedBgColor: Color.black,
    subCategorySelectedBgColor: Color.black,
    categoryUnselectedBgColor: Color.bgWhite,
    categorySelectedBorderColor: Color.black,
    categoryUnselectedColor: Color.black,
    categoryBorder: 0.5,
    categorySelectedColor: Color.bgWhite,
    dropdownBgColor: globalConfigurableData.globalThemeColor,
    dropdownRadioBtnColor: Colors.tradexBlue,
    tradeCardBgColor: Colors.bgWhite,
    hashTagTitleColor: Colors.black,
    hashTagBgColor: !isMobile() ? Colors.bgWhite : '#FAFAFA',
    yesBtnBlock: 'rgba(38, 92, 255, 0.1)',
    noBtnBlock: 'rgba(170, 0, 255, 0.1)',
    noBtnTxt: 'rgb(170, 0, 255)',
    yesBtnTxt: 'rgb(38, 92, 255)',
    showLoaderHome: true,
  },
  Portfolio: {
    cardBgColor: Colors.bgWhite,
    borderColor: Colors.borderColor,
    yesBtnBlock: 'rgba(38, 92, 255, 0.1)',
    noBtnBlock: 'rgba(170, 0, 255, 0.1)',
    yesBtnBorder: 'rgb(38, 92, 255)',
    noBtnBorder: 'rgb(170, 0, 255)',
    noBtnTxt: 'rgb(170, 0, 255)',
    yesBtnTxt: 'rgb(38, 92, 255)',
    btnBorderRadius: 5,
  },
  Event: {
    cardBgColor: Colors.bgWhite,
    borderColor: Colors.borderColor,
    isShowEventShare: '',
    yesBtnBlock: 'rgba(38, 92, 255, 0.1)',
    noBtnBlock: 'rgba(170, 0, 255, 0.1)',
    noBtnTxt: 'rgb(170, 0, 255)',
    yesBtnTxt: 'rgb(38, 92, 255)',
    tipColor: Color.tradexBlue,
    tipBackgroundColor: 'rgba(10, 87, 255, 0.1)',
    InvestedBox: Colors.tradexBlue1,
    InvestedTxt: Colors.tradexBlue,
    StatsBlock: Colors.bgWhite,
    isShowBalanceInPopUp: true,
    yesBtnBg: 'rgba(38, 92, 255, 0.1)',
    noBtnBg: 'rgba(170, 0, 255, 0.1)',
    yesBtnBorder: 'rgb(38, 92, 255)',
    noBtnBorder: 'rgb(170, 0, 255)',
  },
  SingleOrder: {
    switchTabSelectedColor: Colors.yesColor,
    switchTabUnselectedColor: Colors.grey,
    switchTabUnselectedBorderColor: Colors.bgWhite,
    highlightColor: Colors.tradexBlue,
    switchSliderSelectedColor: Colors.black,
    switchSliderUnselectedColor: Colors.tradexBlue1,
    radioBorder: Colors.black,
    inputColor: Colors.bgWhite,
  },
  Wallet: {
    cardBgColor: Colors.bgWhite,
    highlightColor: Colors.tradexBlue,
    transactionBox: Colors.grey5,
    isShowAddWallet: '',
    isShowWithdrawWallet: '',
    isShowFAQ: '',
    isShowKYCStatus: '',
    isShowCouponCodeAddMoney: '',
    walletSummaryBtnColor: Colors.black,
    partnerPopUp: false,
  },
  AddMoney: {
    borderColor: Colors.black,
    disclaimerBgColor: Colors.tradexBlue1,
    disclaimerConfigBgColor: '#F5F7F9',
  },
  Account: {
    googleTheme: 'outline',
    partnerLogin: false,
    showAccount: true,
    imgBgColor: '#F5F5F5',
    isKyc: true,
    listOptions: [
      {
        img: account_profile,
        title: 'My Profile',
        subtitle: 'Manage your basic profile details here',
        redirect: 'profile',
      },
      {
        img: account_profile,
        title: 'Manage KYC & Bank',
        subtitle: 'Manage your KYC and bank account details',
        redirect: 'manageKycBank',
      },
      {
        img: fantasyTab,
        title: 'Rewards',
        subtitle: 'View your rewards and earnings',
        redirect: 'rewards',
      },
      {
        img: account_refer,
        title: 'Invite & Earn',
        subtitle: 'Invite your friends and earn token points.',
        redirect: 'refer',
      },
      {
        img: account_refer,
        title: 'Price View',
        subtitle: 'Select your preferred price range',
        redirect: 'priceView',
      },
      {
        img: account_refer,
        title: 'Choose Language',
        subtitle: 'Choose your preferred language',
        redirect: 'LanguageSelection',
      },
      {
        img: account_telegram,
        title: 'Join Community',
        subtitle: 'Join our discord channel & get latest updates',
        redirect: 'discord',
      },
      {
        img: account_raiseTicket,
        title: 'Frequently Asked Questions',
        subtitle: 'Get answers to the most questions here',
        redirect: 'zendesk',
      },
      {
        img: account_support,
        title: 'Raise a Ticket',
        subtitle: 'In case of any issues, you can contact us instantly',
        redirect: 'RT',
      },
      {
        img: account_support,
        title: 'Log Out',
        subtitle: 'Log out from your account',
        redirect: 'logout',
      },
    ],
  },
  TxnPage: {
    creditAmtColor: '',
    debitAmtColor: '',
    txnTitle: 'My Transactions',
  },
  ...(partnerMap?.isTmr
    ? GlobalScreensTheme1
    : partnerMap?.isKostar
    ? GlobalScreensThemeKostar
    : partnerMap?.isMyMaster
    ? GlobalScreensThemeMyMaster
    : {}),
};

export const Integrations = {
  googleSingIn: '',
  googleAnalytics: '',
  clevertap: '',
  appsflyer: '',
};
